<template>
  <panel :title="$tc('settings.general_settings')">
    <main-input v-model="form.title" :label="$tc('settings.website_name')" :validator="$v.form.title"/>
    <main-textarea v-model="form.description" :label="$tc('settings.website_description')" :validator="$v.form.description"/>
    <main-upload-input v-model="logo" :label="$tc('settings.logo')"/>

    <div class="mt-20">
      <el-checkbox v-model="form.disableEdit" :label="$tc('settings.disable_edit')" />
    </div>
    <div class="mt-20">
      <el-checkbox v-model="form.disableCreate" :label="$tc('settings.disable_create')" />
    </div>

    <div class="mt-30 reset-points-section">
      <h4 class="reset-points-title">{{ $tc('settings.reset_points_title') }}</h4>
      <p class="reset-points-help">{{ $tc('settings.reset_points_help') }}</p>
      <el-button type="danger" plain :loading="resetting" @click="askResetPoints()">
        {{ $tc('settings.reset_points_button') }}
      </el-button>
    </div>

    <template v-slot:footer>
      <div class="flex-end">
        <el-button type="primary" :loading="loading" @click="save()">{{ $tc('general.save') }}</el-button>
      </div>
    </template>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import errorHandler from '@/common/errorHandler.js'

export default {
  props: {
    canEdit: {
      type: Boolean,
      default: false
    },

    members: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      form: {
        title: null,
        description: null,
        disableEdit: false,
        disableCreate: false
      },

      logo: null,

      loading: false,
      resetting: false
    }
  },

  computed: {
    settings () {
      return this.$store.state.app.settings
    }
  },

  created () {
    this.form = {
      title: this.settings.title,
      description: this.settings.description,
      disableEdit: this.settings.disableEdit,
      disableCreate: this.settings.disableCreate
    }

    this.$store.commit('app/set', {
      title: this.$tc('settings.general_settings'),
      breadcrumbs: [
        {
          text: this.$tc('settings.settings')
        },
        {
          text: this.$tc('settings.general_settings')
        }
      ]
    })
  },

  methods: {
    async save () {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) return

      this.loading = true
      try {
        await this.$store.dispatch('settings/update', {
          id: this.settings.id,
          payload: this.form
        })

        if (this.logo) {
          await this.$store.dispatch('settings/upload', {
            id: this.settings.id,
            file: this.logo
          })
        }

        this.$message.success(this.$tc('messages.settings_successfully_updated'))
      } catch (error) {
        errorHandler(error)
      } finally {
        this.loading = false
      }
    },

    async askResetPoints () {
      try {
        await this.$confirm(this.$tc('messages.ask_reset_points'), {
          type: 'warning',
          confirmButtonText: this.$tc('settings.reset_points_button'),
          confirmButtonClass: 'el-button--danger'
        })
      } catch {
        return
      }

      this.resetting = true
      try {
        await this.$store.dispatch('ranking/resetPoints')
        this.$message.success(this.$tc('messages.points_successfully_reset'))
      } catch (error) {
        errorHandler(error)
      } finally {
        this.resetting = false
      }
    }
  },

  validations () {
    return {
      form: {
        title: { required },
        description: { required }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.reset-points-section {
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}
.reset-points-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  color: #f56c6c;
}
.reset-points-help {
  margin: 0 0 12px;
  font-size: 12px;
  color: #909399;
}
</style>
